module.exports = __webpack_public_path__ + "static/media/6.bc327233.png";